import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useNavigate, useLocation } from "react-router-dom";
import { usePermission } from "../../../context/PermissionContext";
import { useAuth } from "../../../context/AuthProvider";
import { useShowAlert } from "../../../context/AlertContext";
import { useNetwork } from "../../../context/NetworkContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import useKeyboardTableNavigation from "../../../constants/useKeyboardTableNavigation";
import Table from "../../../constants/Table";
import DeleteModal from "../../../constants/DeleteModal";
// import InvoiceTemp from "./PurchaseView";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";
import { AddIcon, DeleteIcon, EditIcon, RefreshIcon, ShowIcon, SortDownIcon } from "../../../constants/Icons";

const ListPurchase = () => {
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isEstimateData, setEstimateData] = useState([]);
   const [selectedPurchaseOption, setSelectedPurchaseOption] = useState("PURCHASE");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const perPage = 10;

  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isViewData, setViewData] = useState(null);
  const [isDeleteData, setDeleteData] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  // const [estimate, setEstimation] = useState([]);
  const [isAddModalOpen, setAddModalOpen] = useState(false);

  const [statusFilter, setStatusFilter] = useState("DRAFT");

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { isUser } = useAuth();
  const { permission, hasPermission, globelPopupOpen } = usePermission();
  const navigate = useNavigate();
  const location = useLocation(); // Access location to get state

  const handleListEstimate = async (page = 0) => {
    try {
      if (!checkNetwork()) return;
      setIsLoading(true);
      const data = { pageno: page + 1, limit: perPage };
      const response = await AxiosInstance.get(
        `module/purchase/list?pageno=${page + 1}&limit=${perPage}&status=${statusFilter}`,
      );
      const results = response.data.results || [];
      setEstimateData(results);
      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handleRefresh = async () => {
    await handleListEstimate(currentPage);
  };

  const handleGetEstimation = async (ID) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/purchase/${ID}`);
      const result = response.data.results;
      setViewData(response.data.results);
      setViewModalOpen(true);
      // setEstimation(JSON.parse(result));
      // setEstimation(result);
      return result;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleView = async (item) => {
    handleGetEstimation(item?._id)
    // setViewData(item);
    // setViewModalOpen(true);
  };

  const handleClose = () => {
    setViewModalOpen(false);
    setViewData(null);
    // Clear the location state to prevent re-opening the modal
    navigate(location.pathname, { replace: true, state: {} });
  };

  const handleEdit = (item) => {
    sessionStorage.removeItem("purchaseId"); // ✅ clear old

    navigate("/purchase", {
      state: {
        purchaseData: item,
        isEdit: true,
        navigatelist: "/listpurchase",
      },
      key: item._id,
    });
  };

  const openDeleteModal = (cItem) => {
    setDeleteData(cItem);
    setDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.delete(
        `module/purchase/${isDeleteData?._id}`,
        // {
        //   data: {
        //     estimateid: isDeleteData?._id,
        //   },
        // }
      );
      showAlert("success", "Purchase deleted successfully!");

      const newTotal = totalItems - 1;
      const newTotalPages = Math.ceil(newTotal / perPage);

      if (isEstimateData.length === 1 && currentPage > 0) {
        setCurrentPage((prev) => prev - 1);
        await handleListEstimate(currentPage - 1);
      } else {
        await handleListEstimate(currentPage);
      }

      setTotalItems(newTotal);
      setTotalPages(newTotalPages);
      setDeleteModalOpen(false);

      closeDeleteModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const closeDeleteModal = () => {
    setDeleteData(null);
    setDeleteModalOpen(false);
  };

  // const getColor = (status) => {
  //   switch (status?.toLowerCase()) {
  //     case "active":
  //       return "bg-label-success";
  //     case "cancelled":
  //       return "bg-label-danger";
  //     default:
  //       return "bg-label-secondary";
  //   }
  // };

  const handleAddClose = () => {
    setAddModalOpen(false);
  };

  const handleAddPurchase = () => {
    // ✅ clear old edit session
    sessionStorage.removeItem("purchaseId");

    navigate("/purchase", {
      state: {
        openCreateModal: true,
      },
    });
  };

  const handleDone = () => {
    setViewModalOpen(false);
    navigate("/listpurchase");
  };

  useKeyboardTableNavigation({
    modals: {
      isDeleteModalOpen,
      isViewModalOpen,
      globelPopupOpen,
    },
    onEnter: handleView,
  });

  useEffect(() => {
    handleListEstimate(currentPage);
  }, [currentPage]);

  useEffect(() => {
    handleListEstimate(0);
    setCurrentPage(0);
  }, [statusFilter]);

  useEffect(() => {
    if (location.state?.modalData) {
      setViewData(location.state.modalData);
      setViewModalOpen(true);
    }
  }, [location.state]);

  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="page-breadcrumb d-flex align-items-center mb-3">
          <div className="pb-1">
            <button
              type="button"
              className="btn btn-sm btn-light p-1 shadow-none"
              onClick={handleRefresh}
              disabled={isLoading}
              title="Refresh list"
            >
              <RefreshIcon iClass={`${isLoading ? "bx-spin" : ""}`}/>
            </button>
          </div>
          <div className="breadcrumb-title pe-3">List Purchase</div>
          {/* <div className="ms-auto">
            <button
              type="button"
              className="btn btn-primary mt-2 mt-lg-0"
              onClick={handleLink}
            >
              <i className="ng ng-ng-add-icon"></i> Add Estimate
            </button>
          </div> */}
        </div>

        <div className="row">
          <div className="col">
            <div className="card radius-10 mb-0">
              <div className="card-body px-0">
                <div className="row px-3">
                  <div className="col-lg-2 col-6 d-flex align-items-center">
                    <div>
                      <strong>Total Purchase:</strong>{" "}
                      <span className="badge btn-label-primary fs-15 ">
                        {totalItems || 0}
                      </span>
                    </div>
                  </div>

                  <div className="col-lg-2 col-12 mb-2 mb-lg-0">
                    <div className="input-group">
                      <span className="input-group-text">
                        <SortDownIcon/>
                      </span>
                      <select
                        className="form-select"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="DRAFT">Draft</option>
                        <option value="SUBMITTED">Submitted</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-8 col-6 d-flex justify-content-end ">
                    <button
                      type="button"
                      className="btn btn-primary mt-2 mt-lg-0"
                      onClick={() => handleAddPurchase()}
                    >
                      <AddIcon/> Add Purchase
                    </button>
                  </div>
                </div>

                <Table
                  loading={isLoading}
                  data={isEstimateData}
                  onRowClick={(item) => handleView(item)}
                  columns={[
                    {
                      label: "S.No",
                      render: (_, index) => (
                        <>{currentPage * perPage + index + 1}</>
                      ),
                    },
                    {
                      label: "Purchase No",
                      render: (item) => (
                        <span className="badge rounded-pill bg-label-deep-purple">
                          {item?.purchaseNo}
                        </span>
                      ),
                    },
                    {
                      label: "Purchase Date",
                      render: (item) => (
                        <span className="text-heading fw-medium text-truncate">
                          {
                            DateConverter.ISOToDisplayFormat(
                              DateConverter.convertToTimeZone(
                                item?.purchaseDate,
                                isUser?.timezone,
                              ),
                            ).date
                          }
                        </span>
                      ),
                    },
                    {
                      label: "Supplier",
                      render: (item) => (
                        <div className="d-flex flex-column">
                          <span className="text-nowrap text-heading fw-medium">
                            {item.supplierId ? `${item?.supplierId?.name}` : ""}
                          </span>
                          <span className="text-nowrap">
                            <small>
                              {item.supplierId
                                ? `${item?.supplierId?.number}`
                                : " - "}
                            </small>
                          </span>
                        </div>
                      ),
                    },
                    {
                      label: "Purchase Items",
                      render: (item) => (
                        <>{item?.purchaseItems?.length || 0} Item(s)</>
                      ),
                    },
                    {
                      label: "Grand Total",
                      tdBodyclass:"tdPadding",
                      render: (item) => (
                        <span className="text-heading fw-medium text-truncate">
                          {formatCurrencyFun(item?.totalAmount)}
                        </span>
                      ),
                    },
                    {
                      label: "Status",
                      thClass:"w-12",
                      render: (item) => (
                        <div className="no-print position-relative">
                          <div className=" d-flex justify-content-center align-items-center">
                        <span className="stock-status-badge badge rounded-pill bg-label-blue">
                          {item.status}
                        </span>
                        <div className="order-actions order-actions3 opacity-0 opacity-md-100">
                          <button
                                  type="button"
                                  className="btn-label-info shadow-none me-2"
                                  onClick={(e) => {
                                          e.stopPropagation();
                                           handleView(item)}}
                                >
                                  <ShowIcon/>
                                </button>
                          {item?.status === "DRAFT" && (
                            <>
                              <button
                                type="button"
                                className="btn-label-primary shadow-none me-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEdit(item);
                                }}
                              >
                                <EditIcon/>
                              </button>
                              <button
                                type="button"
                                className="btn-label-danger shadow-none me-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openDeleteModal(item);
                                }}
                              >
                                <DeleteIcon/>
                              </button>
                            </>
                          )}
                        </div>
                        </div>
                        </div>
                      ),
                    },
                    // {
                    //   label: "Actions",
                    //   render: (item) => (
                    //     <div className="order-actions opacity-0 opacity-md-100">
                    //       {/* <button
                    //               type="button"
                    //               className="btn-label-info shadow-none me-2"
                    //               onClick={(e) => {
                    //                       e.stopPropagation();
                    //                        handleView(item)}}
                    //             >
                    //               <i className="bx bx-show"></i>
                    //             </button> */}
                    //       {item?.status === "DRAFT" && (
                    //         <>
                    //           <button
                    //             type="button"
                    //             className="btn-label-primary shadow-none me-2"
                    //             onClick={(e) => {
                    //               e.stopPropagation();
                    //               handleEdit(item);
                    //             }}
                    //           >
                    //             <i className="ng ng-ng-edit-icon"></i>
                    //           </button>
                    //           <button
                    //             type="button"
                    //             className="btn-label-danger shadow-none me-2"
                    //             onClick={(e) => {
                    //               e.stopPropagation();
                    //               openDeleteModal(item);
                    //             }}
                    //           >
                    //             <i className="ng ng-ng-delete-icon"></i>
                    //           </button>
                    //         </>
                    //       )}
                    //     </div>
                    //   ),
                    // },
                  ]}
                />
                {totalPages > 0 && (
                  <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                      previousLabel={"← Previous"}
                      nextLabel={"Next →"}
                      breakLabel={"..."}
                      onPageChange={({ selected }) => {
                        setIsLoading(true);
                        setCurrentPage(selected);
                      }}
                      pageRangeDisplayed={5}
                      pageCount={totalPages}
                      containerClassName="pagination"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      activeClassName="active"
                      forcePage={currentPage}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {isViewModalOpen && (
          // <InvoiceTemp
          //   data={isViewData}
          //   isViewModalOpen={isViewModalOpen}
          //   onClose={handleClose}
          //   onEdit={handleEdit}
          //   onDone={handleDone}
          // />
          <TemplateModalLayout
          isOpen={isViewModalOpen}
          isData={isViewData}
          onClose={handleClose}
          onEdit={handleEdit}
          selectedOption={selectedPurchaseOption}
          setSelectedOption={setSelectedPurchaseOption}
          onDone={handleDone}
          isPurchase={true}
          />
        )}

        {isDeleteModalOpen && (
          <DeleteModal
            onClose={() => setDeleteModalOpen(false)}
            onConfirm={handleDelete}
            isLable={" Purchase " + isDeleteData?.purchaseNo}
            isBtnLoading={isBtnLoading}
          />
        )}

        {/* {isAddModalOpen && (
          <AddPurchase onClose={handleAddClose} handleAdd={handleAddPurchase} />
        )} */}
      </div>
    </div>
  );
};

export default ListPurchase;
